export enum AutomationResult {
  Approve = "approve",
  Reject = "reject",
  ManualReview = "manual_review",
}
